/*
 *
 * GiftCardLanding constants
 *
 */

import { constants } from '../../devUtils';
export const DEFAULT_ACTION = '/GiftCardLanding/DEFAULT_ACTION';
export const FETCH_LANDING_SUCCESS = '/GiftCardLanding/FETCH_LANDING_SUCCESS';
export const STORE_LYRA_GIFTCARD = '/GiftCardLanding/STORE_LYRA_GIFTCARD';
// export const DEFAULT_GIFTCARD_PAYLOAD = {
//   include: 'variations,variation_types',
//   page: 1,
//   payment_method: 'payment_gateway',
//   per_page: 6,
//   product_types: 'evoucher,physical_voucher',
// };

export const LINK_ARRAY = [{
  index: 0,
  link: constants.LINK_GIFTCARD_LANDING,
  value: 'Gift Card Deals',
  eventKey: 'landingPage',
},
{
  index: 1,
  link: constants.LINK_GIFTCARD_LIST,
  value: 'All Gift Cards',
  eventKey: 'allCardsPage',
},
{
  index: 2,
  link: constants.LINK_SPECIAL_DEALS_AND_OFFERS,
  value: 'Special Deals And Offers',
},

];

export const CHECK_EVENT_ACTION_TYPE = (eventType) => {
  switch (eventType) {
    case 'featureBrands':
      return 'Landing Page Featured';
    case 'popularBrands':
      return 'Landing Page Popular';
    case 'bestDiscounts':
      return 'Landing Page Best Discounts';
    case 'multiBrand':
      return 'Landing Page Zaggle Cards';

    default:
      return null;
  }
};

export const ALERT_LYRA_VOUCHER_VALUES = 'Please enter Gift Card Remarks and Amount';



// WEBPACK FOOTER //
// client/containers/GiftCardLanding/constants.js